import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from './modules/components/Typography';
import Grid from '@mui/material/Grid';
import AppAppBar from './modules/views/AppAppBar';
import withRoot from './modules/withRoot';

function Calls() {

  return (
    <React.Fragment>
        <AppAppBar />
            <Container sx={{ mt: 4, mb: 8 }}>
            <Typography variant="h2" align="center" >
                Convocatorias
            </Typography>
            <Typography variant="h3" sx={{ fontFamily: "Kaushan Script", color: "primary.main", marginTop: "24px" }}>Realización</Typography>
            <Grid container>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para estudiantes activos:</Typography>
                    <Typography variant="body1">• Mejor cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor dirección de cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor producción de cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor diseño sonoro</Typography>
                    <Typography variant="body1">• Mejor cinefotografía de cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor diseño de producción en cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor guión original de cortometraje</Typography>
                    <Typography variant="body1">• Mejor edición y montaje en cortometraje de ficción</Typography>
                    <Typography variant="body1">• Mejor cortometraje documental</Typography>
                    <Typography variant="body1">• Mejor concepto creativo de vídeo musical</Typography>
                </Grid>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para egresados:</Typography>
                    <Typography variant="body1">¡No nos olvidamos de ti! Participa en la categoría:</Typography>
                    <Typography variant="body1">• Mejor cortometraje de ficción de tesis</Typography>
                </Grid>
            </Grid>
            <Typography variant="h3" sx={{ fontFamily: "Kaushan Script", color: "primary.main", marginTop: "24px" }}>Animación</Typography>
            <Grid container>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para estudiantes activos:</Typography>
                    <Typography variant="body1">• Mejor animación 2D</Typography>
                    <Typography variant="body1">• Mejor animación 3D {"("}tanto animaciones como renders de modelado{")"}</Typography>
                    <Typography variant="body1">• Mejor animación stop-motion</Typography>
                    <Typography variant="body1">• Mejor animación digital</Typography>
                    <Typography variant="body2">*Todas las obras con duración de entre 30 segundos a 2 minutos</Typography>
                </Grid>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para egresados:</Typography>
                    <Typography variant="body1">¡No nos olvidamos de ti! Participa en la categorías:</Typography>
                    <Typography variant="body1">• Mejor animación 2D</Typography>
                    <Typography variant="body1">• Premio a la creatividad en técnicas de animación tradicional {"("}no 2D ni 3D{")"}</Typography>
                    <Typography variant="body2">*Todas las obras con duración de entre 30 segundos a 3 minutos</Typography>
                </Grid>
            </Grid>
            <Typography variant="h3" sx={{ fontFamily: "Kaushan Script", color: "primary.main", marginTop: "24px" }}>Multimedia</Typography>
            <Grid container>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para estudiantes activos:</Typography>
                    <Typography variant="body1">• Mejor vídeo mapping</Typography>
                    <Typography variant="body1">• Mejor experiencia en realidad aumentada</Typography>
                    <Typography variant="body1">• Mejor experiencia en realidad virtual</Typography>
                    <Typography variant="body1">• Mejor videojuego {"("}cualquier obra jugable de cualquier medio{")"}</Typography>
                    <Typography variant="body2">¡Presenta tu proyecto sin miedo! Instalaremos las cosas necesarias para que puedas proyectarlo</Typography>
                </Grid>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para egresados:</Typography>
                    <Typography variant="body1">¡No nos olvidamos de ti! Participa en la categorías:</Typography>
                    <Typography variant="body1">• Mejor videojuego {"("}cualquier obra jugable de cualquier medio{")"}</Typography>
                    <Typography variant="body1">• Mejor creación electrónica</Typography>
                    <Typography variant="body1">• Mejor experiencia en realidad aumentada</Typography>
                </Grid>
            </Grid>
            <Typography variant="h3" sx={{ fontFamily: "Kaushan Script", color: "primary.main", marginTop: "24px" }}>Publicidad y marketing digital</Typography>
            <Grid container>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para estudiantes activos:</Typography>
                    <Typography variant="body1">• Mejor fotografía publicitaria</Typography>
                    <Typography variant="body1">• Mejor spot publicitario {"("}con una duración de entre 30 segundos y 2 minutos{")"}</Typography>
                    <Typography variant="body1">• Mejor fashion film</Typography>
                    <Typography variant="body2">*Realizadas para cualquier formato: redes, tv, etc.</Typography>
                </Grid>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Para egresados:</Typography>
                    <Typography variant="body1">¡No nos olvidamos de ti! Participa en la categoría:</Typography>
                    <Typography variant="body1">• Premio a la creatividad</Typography>
                    <Typography variant="body2">*Se tomará en consideración la creación de campañas publicitarias y estrategias de marketing para introducción al mercado, 
                    ya sean spots publicitarios como resultado de estas campañas o productos con finalidad hacia las redes sociales</Typography>
                </Grid>
            </Grid>
            <Typography variant="h3" sx={{ fontFamily: "Kaushan Script", color: "primary.main", marginTop: "24px" }}>¿Tienes algún otro tipo de proyecto?</Typography>
            <Grid container>
                <Grid sm={12} md={6}>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>¿Quieres mostrar algo? ¡Participa y exhibe tus proyectos!</Typography>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Animación</Typography>
                    <Typography variant="body1">• Carpetas de desarrollo de proyectos</Typography>
                    <Typography variant="body1">• Maquetas/Dioramas</Typography>
                    <Typography variant="body1">• Esculturas y/o marionetas</Typography>
                    <Typography variant="body1">• Storyboards</Typography>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Publicidad</Typography>
                    <Typography variant="body1">• Fotografía de moda y editorial</Typography>
                    <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "8px" }}>Multimedia</Typography>
                    <Typography variant="body1">• Cualquier tipo de proyecto interactivo, videojuegos, página web, etc.</Typography>
                </Grid>
            </Grid>
        </Container>
        {/* <AppFooter /> */}
    </React.Fragment>
  );
}

export default withRoot(Calls);